/**
 * Jelzi az oldalon (a <html> elem data-teeinblue-editor attribútumával), hogy a teeinblue szerkesztője (fotó vágása,
 * igazítása, előnézet és a többi felugró ablak) nyitva van. Erre a stíluslap elrejti a Shopify Inbox csevegés
 * buborékját, mert az a szerkesztő sarkába lóg, és zavarja a használatot.
 *
 * A teeinblue a vue-js-modal könyvtárral rajzolja az ablakait: van, amelyik a #modals-container tárolóba kerül,
 * van, amelyik a saját űrlapja mellé (névvel ellátott ablak). Ezért az egész oldalon keressük az ismert osztályokat,
 * és a body görgetészáró osztályait is nézzük.
 */

const ATTRIBUTE = 'data-teeinblue-editor';
const DEBOUNCE_MS = 120;
const BLOCK_SCROLL_CLASSES = ['teeinblue-block-scroll', 'vm--block-scroll', 'v--modal-block-scroll'];
const MODAL_SELECTOR = '.vm--container, .vm--modal, .vm--overlay, .v--modal-overlay, .v--modal, .tee-dialog';

/** @param {Element} element */
function isShown(element) {
  const rect = element.getBoundingClientRect();
  if (rect.width === 0 || rect.height === 0) return false;
  const style = getComputedStyle(element);
  return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
}

function isEditorOpen() {
  if (BLOCK_SCROLL_CLASSES.some((name) => document.body.classList.contains(name))) return true;

  return Array.from(document.querySelectorAll(MODAL_SELECTOR)).some(isShown);
}

function update() {
  document.documentElement.toggleAttribute(ATTRIBUTE, isEditorOpen());
}

/** @type {ReturnType<typeof setTimeout> | undefined} */
let timer;

/** Sok apró DOM-változás után is csak egyszer ellenőrzünk (a vizsgálat olcsó, de felesleges minden változásra). */
function scheduleUpdate() {
  clearTimeout(timer);
  timer = setTimeout(update, DEBOUNCE_MS);
}

// A <html> attribútumát mi írjuk, de az a body-n kívül van, így nem váltja ki saját magát.
new MutationObserver(scheduleUpdate).observe(document.body, {
  subtree: true,
  childList: true,
  attributes: true,
  attributeFilter: ['class', 'style'],
});

update();
